import { z } from "zod";
import { evidenceType } from "./enums";

// Metadata for an evidence upload. The file itself is handled outside RHF.
// "" is allowed for "not linked to a request" (a select's empty option); callers
// normalise it to undefined before hitting the API (which validates a uuid).
export const evidenceUploadSchema = z.object({
  type: evidenceType,
  removalRequestId: z.union([z.string().uuid(), z.literal("")]).optional(),
});

export type EvidenceUploadInput = z.infer<typeof evidenceUploadSchema>;
